// @flow
import React from 'react';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Grid, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';

import CustomButton from '../../../elements/CustomButton/CustomButton';

import {colors} from '../../../assets/styles/colors';
import {PropTypes} from 'prop-types';

import type {RootState} from '../..';
import type {Dispatch} from 'redux';
import type {
  SocialMedia,
  // ShippingMethod,
  // PaymentMethod,
  // StoreInformation,
} from '../../../entities';
import Collapsible from '../../../elements/Collapsible/Collapsible';

export default connect(
  (state: RootState) => ({
    categoriesCount: state.categories.categories
      ? state.categories.categories.length
      : undefined,
    information: state.ui.storeInformation,
    socialMedia: state.information.socialMedia,
    paymentMethods: state.paymentMethodConfig.paymentMethods,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({}, dispatch)
)(OtherConfigurations);

type Props = {
  socialMedia?: SocialMedia[],
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: theme.spacing(1, 0),
  },
  title: {
    color: ' #3A3A49',
    fontWeight: 600,
    fontSize: '14px',
  },
  dashboardItem: {
    marginTop: 'unset !important',
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    background: 'white',
    // padding: '15px',
    borderRadius: '12px',
    boxShadow:
      '0px 0px 1px rgba(181, 181, 181, 0.2), 0px 2px 8px rgba(209, 209, 209, 0.16)',
  },
  dashboardHeader: {
    margin: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    '& img': {
      marginRight: '0.5rem',
    },
  },
  description: {
    display: 'flex',
    alignItems: 'center',
  },
  configurationName: {
    color: '#55556D',
    fontSize: '12px',
    marginLeft: theme.spacing(1),
  },
  checkedCheckbox: {
    color: colors.success,
  },
  divider: {
    background: colors.grey300,
  },
  videoBtn: {
    fontSize: '12px',
  },
  linkConfigure: {
    marginBottom: '12px',
    background: 'white',
    width: '100%',
    borderRadius: '8px',
    border: `1px solid ${colors.grey200}`,
    boxShadow:
      '0px 0px 1px rgba(181, 181, 181, 0.2), 0px 2px 8px rgba(209, 209, 209, 0.16)',
    '&:hover': {
      background: 'white',
      filter: 'brightness(0.95)',
    },
  },
  linkConfigureLabel: {
    justifyContent: 'left',
    whiteSpace: 'pre-wrap',
  },
  seeTutosBtn: {
    marginTop: theme.spacing(3),
    borderRadius: '6px',
    background: colors.warning,
    '&:hover': {
      background: colors.warning,
      filter: 'brightness(0.95)',
    },
  },
}));
function OtherConfigurations(props: Props) {
  const {socialMedia} = props;
  const classes = useStyles();
  const pendingConfigurationsToShow = [
    {
      name: 'Integra tus redes sociales',
      video: '',
      // completed: false,
      completed: !!socialMedia && !!socialMedia.length,
      to: '/my-store/social-medias',
    },
    {
      name: 'Personaliza tu proceso de ventas',
      video: '',
      completed: false,
      to: '/configure/sales-process',
    },
    {
      name: 'Activa Facebook Shop/Instagram Shopping',
      video: '',
      completed: false,
      to: '/my-store/social-medias/facebook-integration',
    },
  ];

  // const progress = useMemo(() => {
  //   const completed = pendingConfigurationsToShow.reduce(
  //     (acum, s) => (!!s.completed ? acum + 1 : acum),
  //     0
  //   );
  //   return Math.floor(
  //     parseFloat(
  //       ((completed / pendingConfigurationsToShow.length) * 100).toFixed(2)
  //     )
  //   );
  // }, [pendingConfigurationsToShow]);

  // const allPendingCompleted = useMemo(() => progress && progress >= 100, [
  //   progress,
  // ]);

  // const checkedCheckbox = (
  //   <CheckCircleRounded
  //     className={classes.checkedCheckbox}
  //     style={{fontSize: '1.5rem'}}
  //   />
  // );
  // const uncheckedCheckbox = (
  //   <RadioButtonUnchecked style={{fontSize: '1.5rem', color: 'gray'}} />
  // );

  // if (allPendingCompleted) return <></>;
  return (
    <Grid item xs={12}>
      <Collapsible
        startClosed
        title="Otras Configuraciones"
        className={classes.dashboardItem}
      >
        {pendingConfigurationsToShow.map(
          ({name, completed, video, to}, idx) =>
            !completed && (
              <CustomButton
                key={`configure-${idx}-${name}`}
                variant="contained"
                classes={{
                  root: classes.linkConfigure,
                  label: classes.linkConfigureLabel,
                }}
                to={to}
              >
                <Typography className={classes.configurationName}>
                  {name}
                </Typography>
              </CustomButton>
            )
        )}
      </Collapsible>
    </Grid>
  );
}

OtherConfigurations.propTypes = {
  socialMedia: PropTypes.array,
};
